import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { LedgerDetailSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/wage-ledger/_layout/ledger/$ledgerId/')({
  validateSearch: zodValidator(LedgerDetailSearchSchema)
});